module.exports = __webpack_public_path__ + "20a819dd91719dd89299b72027f4d3d3.svg";